// src/redux/briefing/briefingSlice.js
import { createSlice } from '@reduxjs/toolkit';

export const briefingSlice = createSlice({
  name: 'briefing',
  initialState: {
    section: 'ops', // ops or safety or crossborder
    line: 'Briefings', // Old Briefings or Briefings or Trailers
  },
  reducers: {
    setBriefing: (state, action) => action.payload,
  },
});

export const { setBriefing } = briefingSlice.actions;
export default briefingSlice.reducer;
